import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './TableRow.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tr",
    { staticClass: "table-row", on: { click: _vm.onClick } },
    _vm._l(_vm.columns, function(column, index) {
      return _c("TableRowCell", {
        key: column.id,
        attrs: {
          value: _vm.row[column.id],
          "sticky-left": _vm.stickyLeft && index === 0,
          "sticky-right": _vm.stickyRight && index === _vm.columns.length - 1
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function(props) {
                return _vm._t(
                  column.id,
                  [
                    _c("span", { staticClass: "table-row-cell-value" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.row[column.id]) +
                          "\n            "
                      )
                    ])
                  ],
                  { row: _vm.row },
                  props
                )
              }
            }
          ],
          null,
          true
        )
      })
    }),
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-1ccd8b19";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Table/TableRow.vue.js